// カバー画像スライド
const pcImages = document.querySelectorAll('.pc-slider-image');
const spImages = document.querySelectorAll('.sp-slider-image');
let currentIndex = 0;

function updateImages(images) {
    if (images.length > 1) {
        images[currentIndex].classList.add('active');

        setInterval(() => {
            images[currentIndex].classList.remove('active');
            currentIndex = (currentIndex + 1) % images.length;
            images[currentIndex].classList.add('active');
    }, 6000); 
    } else if (images.length === 1) {
        images[0].classList.add('active');
    }
}

function initSliders() {
    const windowWidth = window.innerWidth;
    if (windowWidth > 480) {
        updateImages(pcImages);
    } else {
        updateImages(spImages);
    }
}

window.addEventListener('resize', initSliders);
initSliders(); // 初期ロード時にスライダーを初期化

// ナビゲーション処理
const fixNav = document.getElementById('fix-nav');
const coverImage = document.getElementById('main');
const coverImageHeight = coverImage.clientHeight;
const sections = document.querySelectorAll('#message, #events, #countdown');
const navLinks = document.querySelectorAll('#fix-nav a');
const burger = document.querySelector('.burger-menu');
const messageSection = document.getElementById('message');

function updateNav() {
    if (window.innerWidth < 769) {
        return;
    }
    let currentSection = '';
    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        const sectionHeight = section.offsetHeight;
        if (window.scrollY >= sectionTop - 1 && window.scrollY < sectionTop + sectionHeight - 1) {
            currentSection = section.getAttribute('id');
        }
    });

    // ページの一番下に到達した場合
    if (scrollPosition >= documentHeight - 1) {
        currentSection = 'rsvp';
    }

    navLinks.forEach(link => {
        link.classList.remove('active');
        if (currentSection && link.getAttribute('href').includes(currentSection)) {
            link.classList.add('active');
        }
    });

    // fixNavの表示/非表示を切り替え
    const messageSectionBottom = messageSection.getBoundingClientRect().bottom + window.pageYOffset;
    const messageSectionTop = messageSection.getBoundingClientRect().top + window.pageYOffset;
    const coverImageBottom = coverImage.getBoundingClientRect().bottom + window.pageYOffset;

    if (window.scrollY >= coverImageBottom) {
        fixNav.style.position = 'fixed';
        fixNav.style.top = '80px';
        fixNav.classList.add('active');
    } else if (window.scrollY + window.innerHeight >= messageSectionTop) {
        fixNav.classList.add('active');
        fixNav.style.position = 'absolute';
        fixNav.style.top = `${messageSectionTop + 80}px`;
    } else {
        fixNav.classList.remove('active');
        fixNav.style.position = '';
        fixNav.style.top = '';
    }
}
window.addEventListener('scroll', function() {
    updateNav();
});
window.addEventListener('resize', function() {
    updateNav();
});
// document.addEventListener('DOMContentLoaded', function() {
    updateNav();
// });

burger.addEventListener('click', function () {
    fixNav.classList.toggle('open');
});
navLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        fixNav.classList.remove('open');
    });
});

// イベントタイトル切り替え
const eventTitle = document.querySelector('#events h2 span');
const isSingleEvent = document.body.id === 'layout2';
if (!isSingleEvent) {
    eventTitle.textContent = 'EVENTS';
} else {
    eventTitle.textContent = 'EVENT';
}